export const patriotic = [
  {
    number: 'P100',
    hasModel: true,
  },
  {
    number: 'P101',
    hasModel: false,
  },
  {
    number: 'P103',
    hasModel: true,
  },
  {
    number: 'P104',
    hasModel: false,
  },
  {
    number: 'P105',
    hasModel: false,
  },
  {
    number: 'P106',
    hasModel: true,
  },
  {
    number: 'P107',
    hasModel: false,
  },
  {
    number: 'P108',
    hasModel: false,
  },
  {
    number: 'P109',
    hasModel: false,
  },
  {
    number: 'P111',
    hasModel: true,
  },
  {
    number: 'P114',
    hasModel: false,
  },
  {
    number: 'P115',
    hasModel: false,
  },
  {
    number: 'P116',
    hasModel: true,
  },
  {
    number: 'P117',
    hasModel: true,
  },
  {
    number: 'P118',
    hasModel: false,
  },
  {
    number: 'P119',
    hasModel: false,
  },
  {
    number: 'P120',
    hasModel: false,
  },
  {
    number: 'P122',
    hasModel: true,
  },
  {
    number: 'P123',
    hasModel: true,
  },
  {
    number: 'P126',
    hasModel: true,
  },
  {
    number: 'P127',
    hasModel: true,
  },
  {
    number: 'P131',
    hasModel: true,
  },
  {
    number: 'P134',
    hasModel: false,
  },
  {
    number: 'P135',
    hasModel: false,
  },
  {
    number: 'P137',
    hasModel: false,
  },
  {
    number: 'P139',
    hasModel: false,
  },
  {
    number: 'P140',
    hasModel: true,
  },
  {
    number: 'P141',
    hasModel: false,
  },
  {
    number: 'P142',
    hasModel: false,
  },
  {
    number: 'P143',
    hasModel: false,
  },
  {
    number: 'P144',
    hasModel: false,
  },
  {
    number: 'P145',
    hasModel: false,
  },
  {
    number: 'PX',
    hasModel: false,
  },
];
